import {Store} from "vuex";
import {RecordingStatuses} from "@share/web-conferences/enums/RecordingStatuses";
import {statusUpdateMessage} from "@share/web-conferences/helpers/recordings/StatusUpdateMessage";
import { noticeActions } from "@service/store/notice/actions";

export const sendRecordingNotification = (store: Store<any>, status: RecordingStatuses) => {
    const msg = statusUpdateMessage(status);
    if (msg) {
        store.dispatch(noticeActions.submitNotice, msg);
    }
}